<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">

        <FormSection>
            <template #title>
                Award Information
            </template>

            <FormGroup
                name="amount"
                label="Amount">
                <Input
                    v-model="form.amount"
                    name="amount"
                    class="max-w-40"
                    placeholder="e.g. 20 or -10"/>
            </FormGroup>

            <FormGroup
                name="reason"
                label="Amount">
                <Textarea
                    v-model="form.reason"
                    name="reason"
                    placeholder="The reason for awarding the credits..."/>
            </FormGroup>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"/>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";
import File from "@/Components/Form/File.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Label from "@/Components/Form/Label.vue";
import Checkbox from "@/Components/Form/Checkbox.vue";
import {optionsToArray} from "@/Lib/Helpers";
import axios from "axios";

export default {

    name: "AwardForm",

    emits: ['submit'],

    inject: ['form'],

    components: {
        FormSection,
        FormGroup,
        Input,
        Textarea,
    }
};

</script>
